import { gql } from '@apollo/client';
import { USER_FRAGMENT } from './queries';

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user {
        ...UserFields
      }
    }
  }
  ${USER_FRAGMENT}
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout
  }
`;

export const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken {
    refreshToken {
      user {
        id
      }
    }
  }
`;

export const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const UPDATE_TIME_ZONE_MUTATION = gql`
  mutation UpdateTimeZone($timeZone: String!) {
    updateTimeZone(timeZone: $timeZone) {
      id
      timeZone
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`;

export const SAVE_DOCUMENT_TEXT_MUTATION = gql`
  mutation SaveDocumentText($path: String!, $content: String!, $expectedVersion: Int) {
    saveDocumentText(path: $path, content: $content, expectedVersion: $expectedVersion) {
      path
      content
      updatedAt
      version
    }
  }
`;

export const DELETE_DOCUMENT_MUTATION = gql`
  mutation DeleteDocument($path: String!) {
    deleteDocument(path: $path)
  }
`;

export const RESTORE_DOCUMENT_VERSION_MUTATION = gql`
  mutation RestoreDocumentVersion($path: String!, $version: Int!) {
    restoreDocumentVersion(path: $path, version: $version) {
      path
      version
      content
    }
  }
`;

export const CREATE_SPACE_MUTATION = gql`
  mutation CreateSpace($name: String!, $slug: String!) {
    createSpace(name: $name, slug: $slug) {
      id
      name
      slug
      members {
        id
        email
        displayName
      }
      createdAt
      updatedAt
    }
  }
`;

export const ADD_SPACE_MEMBER_MUTATION = gql`
  mutation AddSpaceMember($spaceId: ID!, $email: String!) {
    addSpaceMember(spaceId: $spaceId, email: $email) {
      id
      email
      displayName
    }
  }
`;

export const REMOVE_SPACE_MEMBER_MUTATION = gql`
  mutation RemoveSpaceMember($spaceId: ID!, $userId: ID!) {
    removeSpaceMember(spaceId: $spaceId, userId: $userId)
  }
`;

export const SEND_CHAT_MESSAGE_MUTATION = gql`
  mutation SendChatMessage($sessionId: ID, $text: String!) {
    sendChatMessage(sessionId: $sessionId, text: $text) {
      runId
      sessionId
    }
  }
`;

export const RESPOND_TO_APPROVAL_MUTATION = gql`
  mutation RespondToApproval($sessionId: ID!, $approve: Boolean!) {
    respondToApproval(sessionId: $sessionId, approve: $approve) {
      runId
      sessionId
    }
  }
`;

export const RENAME_CHAT_SESSION_MUTATION = gql`
  mutation RenameChatSession($id: ID!, $title: String!) {
    renameChatSession(id: $id, title: $title) {
      id
      title
      state
      updatedAt
    }
  }
`;

export const DELETE_CHAT_SESSION_MUTATION = gql`
  mutation DeleteChatSession($id: ID!) {
    deleteChatSession(id: $id)
  }
`;

export const REFRESH_INSIGHTS_MUTATION = gql`
  mutation RefreshInsights {
    refreshInsights {
      status
      content
      updatedAt
    }
  }
`;

export const CONNECT_GITHUB_REPO_MUTATION = gql`
  mutation ConnectGithubRepo($repoFullName: String!, $branch: String!, $token: String!) {
    connectGithubRepo(repoFullName: $repoFullName, branch: $branch, token: $token) {
      available
      connected
      repoFullName
      branch
      state
      attentionReason
      lastSyncedAt
    }
  }
`;

export const DISCONNECT_GITHUB_REPO_MUTATION = gql`
  mutation DisconnectGithubRepo {
    disconnectGithubRepo
  }
`;

export const START_STRAVA_CONNECT_MUTATION = gql`
  mutation StartStravaConnect {
    startStravaConnect
  }
`;

export const DISCONNECT_STRAVA_MUTATION = gql`
  mutation DisconnectStrava {
    disconnectStrava
  }
`;

export const REGISTER_PUSH_SUBSCRIPTION_MUTATION = gql`
  mutation RegisterPushSubscription($endpoint: String!, $p256dh: String!, $auth: String!) {
    registerPushSubscription(endpoint: $endpoint, p256dh: $p256dh, auth: $auth) {
      available
      enabled
      vapidPublicKey
    }
  }
`;

export const UNREGISTER_PUSH_SUBSCRIPTION_MUTATION = gql`
  mutation UnregisterPushSubscription($endpoint: String!) {
    unregisterPushSubscription(endpoint: $endpoint) {
      available
      enabled
      vapidPublicKey
    }
  }
`;

export const SEND_TEST_NOTIFICATION_MUTATION = gql`
  mutation SendTestNotification {
    sendTestNotification
  }
`;
